



















helpers = require('../../../../helpers.coffee')

view_model = {
  props: ['notification', 'table']

  data: ->
    current_user: Session.current_user
    go_to: '/tarefas'

  methods:
    loadTask: (action) ->
      fn = switch action
        when 'task_email' then @openCompose
        when 'task_phonecall' then @openDialer
        when 'mask_as_done' then @doTask
        else @doTask
      @tasks_resources.get fn, @unknownError, id: @notification.metadata.task_ids[0]
      @closeDropdown()

    openCompose: (data) ->
      task = data.task
      event.originalEventName = 'Compose::Open'
      EventsBus.$emit 'Compose::Open', { event, task }

    openDialer: (data) ->
      task = data.task
      contact = task.contact
      number_type = if contact.cellphone then 'cellphone' else 'telefone'
      number = contact.cellphone || contact.telephone
      event.originalEventName = 'open-dialer'
      data = { contact: contact, task: task, number: number, number_type: number_type }
      EventsBus.$emit 'open-dialer', data

    doTask: (data) ->
      data.task.markAsDone()
      @tasks_resources.save @taskUpdated, @unknownError, data.task.serialize(['id', 'done_at'])

    taskUpdated: (data) ->
      task = data.task
      alertify.success('Tarefa atualizada com sucesso')
      Vue.set( @notification, 'task_done_at', task.done_at )
      EventsBus.$emit 'Task::Done', task
      EventsBus.$emit 'NotificationTask::Done', @notification

  computed:
    done_task: ->
      @notification.task_done_at

    multiple_tasks: ->
      @notification.metadata?.task_ids?.length > 1

    show_do_task: ->
      @notification.kind == 'task_email' || @notification.kind == 'task_phonecall'

    due_on: ->
      moment(@notification.task_due_on).format('LT')

    text: ->
      if @notification.count > 1
        " #{@notification.count} tarefas" + @kind_text
      else
        " uma tarefa" + @kind_text

    contact_name: ->
      if @notification.contact_name
        " para "+@notification.contact_name
      else
        ""
    flow_name: ->
      if @notification.flow_name
        " do fluxo "+@notification.flow_name
      else
        ""

    kind_text: ->
      switch @notification.kind
        when 'task_email' then ' de email '
        when 'task_social' then ' de social '
        when 'task_linkedin' then ' de InMail '
        when 'task_phonecall' then ' de ligação '
        else ''

  created: ->
    @tasks_resources = new TasksResource
}

exports.default = helpers.vue_include(view_model, helpers.notifications.kind_wrapper)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/kind/task.vue